// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
export const adjustedPerformanceTimestamp: any = (timestamp: any) =>
	typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
